import client from './client';

export default {
  all(page = 1) {
    return client.get('/reps')
      .query({
        page: page
      })
      .end();
  },

  create(params) {
    return client.post('/reps')
      .send(params)
      .end();
  },

  fetchSelf() {
    return client.get('/reps/self').end();
  },

  updateSelf(params) {
    return client.patch('/reps/self')
      .send(params)
      .end();
  },

  search(params) {
    return client.get('/reps/search')
      .query(params)
      .end();
  },
  block(params) {
    return client.post('/reps/block')
      .query(params)
      .end();
  },
  unblock(params) {
    return client.post('/reps/unblock')
      .query(params)
      .end();
  },
  activateRep(params) {
    return client.post(`/reps/${params.id}/activate_rep`)
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/repAPI.js